import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=b2d04236&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d04236",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2d04236')) {
      api.createRecord('b2d04236', component.options)
    } else {
      api.reload('b2d04236', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=b2d04236&scoped=true&", function () {
      api.rerender('b2d04236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Uvb14RvYWP8G/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports